import {
  DataTable,
  List,
  ListActions,
  NumberField,
  ReferenceField,
  SearchInput,
  TextField,
} from "../common";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export const DesignationList = () => (
  <List
    title="Designations"
    filters={filters}
    actions={<ListActions label="Add Designation" />}
    sort={{ field: "title", order: "ASC" }}
  >
    <div className="employees-table-container">
      <DataTable rowClick="edit" className="employees-table">
        <DataTable.Col source="title" label="Designation" className="employee-name" />
        <DataTable.Col source="level" label="Level">
          <NumberField source="level" />
        </DataTable.Col>
        <DataTable.Col label="Department">
          <ReferenceField
            source="department_id"
            reference="hr_departments"
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>
        </DataTable.Col>
      </DataTable>
    </div>
  </List>
);

